import React from 'react';
import styles from './styles.scss';
import {connect} from 'react-redux';
import NonEditableInput from 'jd-library/NonEditableInput';

function FixedBoxContainer({item}) {
    const {
        s_dnm,
        s_type_options
    } = item;
    return (
        <div className={styles["fixedbox-container"]}>
            <NonEditableInput 
                className={styles["fixedbox-input"]}
                inputText={s_type_options.toString()}
                labelText={s_dnm}
            />
        </div>
    )
}


const mapStateToProps = (state, props) => {
    return {
        ...props,
        item: state.productSpecification.editablePuvSpecAttributes[props.parentIndex]
    }
}

export default connect(mapStateToProps, null)(FixedBoxContainer)